import { render, staticRenderFns } from "./AttrTimewait.vue?vue&type=template&id=cb3c84b2&scoped=true"
import script from "./AttrTimewait.vue?vue&type=script&lang=js"
export * from "./AttrTimewait.vue?vue&type=script&lang=js"
import style0 from "./AttrTimewait.vue?vue&type=style&index=0&id=cb3c84b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3c84b2",
  null
  
)

export default component.exports